export default (function () {
  /* eslint no-eval: 0 */
  return this || (1, eval)('this');
})();
